import { useTranslation } from "react-i18next";

export default function ContactHero() {
  const { t } = useTranslation();
  return (
    <section className="relative overflow-hidden pt-32 pb-16">
      {/* Subtle bg gradient */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: "radial-gradient(ellipse 60% 40% at 50% 0%, rgba(34,197,94,0.08) 0%, transparent 70%)",
        }}
      ></div>

      <div className="relative max-w-3xl mx-auto px-6 text-center">
        <span
          className="inline-flex items-center gap-2 text-xs font-medium px-3 py-1.5 rounded-full mb-6"
          style={{ backgroundColor: "rgba(34,197,94,0.1)", color: "var(--accent)", border: "1px solid rgba(74,222,128,0.2)" }}
        >
          <i className="ri-mail-send-line text-xs"></i>
          {t("contact.badge")}
        </span>
        <h1 className="text-4xl md:text-5xl font-bold mb-5 leading-tight" style={{ color: "var(--text-primary)" }}>
          {t("contact.hero.title")}
        </h1>
        <p className="text-sm md:text-base leading-relaxed" style={{ color: "var(--text-muted)" }}>
          {t("contact.hero.desc")}
        </p>
      </div>
    </section>
  );
}